module.exports = __webpack_public_path__ + "static/media/ic-modal-new.c1e1b427.svg";